module.exports = __webpack_public_path__ + "static/media/phone-call.c3ed6e6a.svg";